"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderStatuses = exports.DeliveryTypes = void 0;
const OrderStatuses = exports.OrderStatuses = {
  PLACED: "placed",
  DRAFT: "draft",
  INVOICED: "invoiced",
  REJECTED: "rejected",
  DELIVERED: "delivered",
  CANCELLED: "cancelled",
  PARTIALLY_INVOICED: "partially_invoiced"
};
const DeliveryTypes = exports.DeliveryTypes = {
  DELIVERY: "delivery",
  PICKUP: "pickup"
};